import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import SectionHeading from '../../components/ui/SectionHeading';
import AnimatedSection from '../../components/ui/AnimatedSection';

const LocalSEO = () => {
  useSEO({
    // Length: 55 characters
    title: 'Local SEO NYC | #1 Ranking in Manhattan & Brooklyn NYC',
    description: 'Expert Local SEO for NYC businesses. Increase local traffic, outrank competitors in the Google Map Pack, and dominate searches in all boroughs.',
  });

  const boroughs = [
    { name: "Manhattan SEO", desc: "The highest competition zone. We utilize hyper-specific neighborhood targeting (SoHo, Midtown, Financial District) to capture elite clientele." },
    { name: "Brooklyn SEO", desc: "Targeting the rapidly growing markets in Williamsburg, DUMBO, and beyond. We focus on creative, high-engagement local optimization." },
    { name: "Queens SEO", desc: "Optimizing for diverse, high-volume local searches in Astoria, Long Island City, and Flushing." },
    { name: "The Bronx SEO", desc: "Capturing emerging market share and solidifying local brand dominance in local service sectors." },
    { name: "Staten Island SEO", desc: "Building unshakeable local authority and community trust through localized content and citation networks." }
  ];

  return (
    <div className="pt-20 pb-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="Hyper-Local Dominance" 
            title="Local SEO for NYC Businesses" 
            description="Ranking in 'New York' is too broad. To drive real foot traffic and local leads, you must dominate the specific boroughs and neighborhoods."
          />
        </AnimatedSection>

        <div className="mt-16 bg-slate-950 rounded-3xl p-8 md:p-12 border border-slate-800">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 border-b border-slate-800 pb-4">Borough-Specific Optimization Strategies</h3>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-10">
            {boroughs.map((b, i) => (
              <AnimatedSection key={i} delay={i * 0.1}>
                <h4 className="text-xl font-bold text-blue-400 mb-3">{b.name}</h4>
                <p className="text-slate-400 leading-relaxed">{b.desc}</p>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocalSEO;